import React from "react";
import PropTypes from "prop-types";
import { Modal, Input, Textarea, Button } from "../../../components/ui";
import Multiselect from "multiselect-react-dropdown";

const CreateSubChannelModal = ({
  show,
  onHide,
  subChannelDetails,
  onChannelNameChange,
  onChannelDescriptionChange,
  memberOptions,
  onMemberSelect,
  onMemberRemove,
  onCancel,
  onSubmit,
  loading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      title={
        <span className="comm-teams__modal-title">Create Sub Channel</span>
      }
      size="lg"
    >
      <div className="comm-teams__modal-form">
        <Input
          label="Channel Name"
          value={subChannelDetails.name}
          onChange={onChannelNameChange}
          type="text"
          placeholder="Enter Channel Name"
        />

        <Textarea
          label="Channel Description"
          value={subChannelDetails.description}
          onChange={onChannelDescriptionChange}
          id="exampleFormControlTextarea1"
          rows={3}
        />

        <div className="create-sub-channel">
          <label className="comm-teams__modal-field-label">Add Members</label>
          <Multiselect
            options={memberOptions}
            onSelect={onMemberSelect}
            onRemove={onMemberRemove}
            displayValue="name"
            closeOnSelect="false"
          />
        </div>

        <div className="comm-teams__modal-footer">
          <Button variant="secondary" type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            loading={loading}
            type="button"
            onClick={onSubmit}
          >
            Create
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CreateSubChannelModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  subChannelDetails: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  onChannelNameChange: PropTypes.func.isRequired,
  onChannelDescriptionChange: PropTypes.func.isRequired,
  memberOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
  onMemberSelect: PropTypes.func.isRequired,
  onMemberRemove: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default CreateSubChannelModal;
